import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { initLenis, scrollToTop } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Expertise from "@/components/Expertise";
import Journey from "@/components/Journey";
import Membership from "@/components/Membership";
import Academic from "@/components/Academic";
import LittleOnes from "@/components/LittleOnes";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => initLenis(), []);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div data-testid="home-page" className="relative">
      <div className="grain-overlay fixed inset-0 z-[90] pointer-events-none opacity-[0.05]" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Expertise />
        <Journey />
        <Membership />
        <Academic />
        <LittleOnes />
        <Contact />
      </main>
      <Footer />
      <button
        data-testid="back-to-top-button"
        onClick={scrollToTop}
        aria-label="Back to top"
        className={`fixed bottom-6 right-6 z-[60] w-12 h-12 rounded-full bg-[#70435F] text-white flex items-center justify-center shadow-soft transition-all duration-500 hover:bg-[#5A344C] ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <ArrowUp size={19} strokeWidth={1.8} />
      </button>
    </div>
  );
};

export default Home;
